<template>
  <div>
    <input type="file" ref="input_video" v-show="false" @change="mudarVideo" accept="video/*" />

    <v-card
      v-if="video"
      style="display: flex; align-items: center; justify-content: center; text-align: center; flex-direction: column"
      class="pa-0"
    >
      <v-card-text class="pa-0">
        <video
          v-if="video"
          ref="video"
          id="video"
          muted
          width="100%"
          metadata="metadata"
          style="border-radius: 4px 4px 0px 0px"
          @loadedmetadata="metadata"
        >
          <source :src="video" />
        </video>
      </v-card-text>
      <div style="width: 100%; text-align: left" class="pa-2 pt-1">
        <v-btn icon @click="play">
          <v-icon>mdi-play</v-icon>
        </v-btn>
        <v-btn icon @click="pause">
          <v-icon>mdi-pause</v-icon>
        </v-btn>
        <v-btn icon @click="stop">
          <v-icon>mdi-stop</v-icon>
        </v-btn>
        <v-btn icon @click="fullScreen">
          <v-icon>mdi-fullscreen</v-icon>
        </v-btn>
        <v-btn
          style="float: right"
          fab
          small
          color="accent"
          @click="abrirDialogoExcluirVideo"
          v-if="!esconderBotaoExcluir"
        >
          <v-icon>delete</v-icon>
        </v-btn>
      </div>
    </v-card>

    <v-card
      v-else
      v-show="!esconderAdicionarVideo"
      class="pa-4"
      style="display: flex; align-items: center; justify-content: center; text-align: center"
    >
      <v-img :src="blankImg" aspect-ratio="1" class="grey lighten-2 white--text align-end">
        <v-card-text class="pa-0">
          <span
            class="primary--text"
            style="width: 100%; text-align: center"
          >Clique aqui adicionar o vídeo</span>
          <v-btn rounded class="ma-2" color="primary" @click.stop="$refs.input_video.click()">
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-text>
      </v-img>
    </v-card>

    <as-dialogo ref="dialogoExcluirVideo" title="Excluir vídeo" max-width="440px" hideCloseButton>
      <v-label>Tem certeza que deseja excluir o vídeo?</v-label>
      <div class="pt-4" style="display: flex; justify-content: flex-end;">
        <v-btn depressed class="mr-4" @click="$refs.dialogoExcluirVideo.fechar()">Cancelar</v-btn>
        <v-btn
          depressed
          color="error"
          @click="excluirVideo"
          :disabled="excluindo"
          :loading="excluindo"
        >Excluir</v-btn>
      </div>
    </as-dialogo>
  </div>
</template>

<script>
export default {
  name: "AsLoadVideo",

  props: {
    value: {
      type: String,
      default: "",
    },

    limiteMinimoDuracao: {
      default: 5,
    },

    limiteMaximoDuracao: {
      default: 31,
    },

    tamanhoMaximo: {
      default: 5242880,
    },

    alturaMinima: {
      default: 360,
    },

    larguraMinima: {
      default: 640,
    },

    alturaMaxima: {
      default: 1080,
    },

    larguraMaxima: {
      default: 1920,
    },

    esconderBotaoExcluir: {
      type: Boolean,
      default: false,
    },

    esconderAdicionarVideo: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      blankImg: `data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAH0AfQDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AKpg${"A".repeat(
        2047
      )}//9k=`,
      video: "",
      excluindo: false,
      mensagem: {
        titulo: "",
        texto: "",
      },
    };
  },

  methods: {
    mudarVideo() {
      this.video = "";

      let file = this.$refs.input_video.files[0];

      let reader = new FileReader();
      reader.onload = () => {
        const dataURL = reader.result;

        if (this.tamanhoValido()) {
          this.video = dataURL;
          this.$emit("input", this.video);
        }
      };
      reader.readAsDataURL(file);
    },

    tamanhoValido() {
      if (this.$refs.input_video.files[0].size > this.tamanhoMaximo) {
        this.mensagem.titulo = "Atenção";
        this.mensagem.texto = `Este arquivo de vídeo muito grande - ${(
          this.$refs.input_video.files[0].size /
          1024 /
          1024
        ).toFixed(1)} megabytes! O limite é ${(
          this.tamanhoMaximo /
          1024 /
          1024
        ).toFixed(1)} megabytes.`;
        this.$emit("onMensagem", this.mensagem);
        return false;
      }

      return true;
    },
    metadata() {
      const video = this.$refs.video;
      const duration = video.duration;
      const height = video.videoHeight;
      const width = video.videoWidth;

      if (video.duration < this.limiteMinimoDuracao) {
        this.mensagem.titulo = "Atenção";
        this.mensagem.texto =
          `A duração deste arquivo de vídeo muito pequena - ${video.duration.toFixed(
            0
          )} segundos! O mínimo é ` +
          this.limiteMinimoDuracao +
          ` segundos.`;
        this.video = "";
        this.$emit("onMensagem", this.mensagem);
      }

      if (video.duration > this.limiteMaximoDuracao) {
        this.mensagem.titulo = "Atenção";
        this.mensagem.texto =
          `A duração deste arquivo de vídeo muito grande - ${video.duration.toFixed(
            0
          )} segundos! O limite é ` +
          this.limiteMaximoDuracao +
          ` segundos.`;
        this.video = "";
        this.$emit("onMensagem", this.mensagem);
      }

      if (
        video.videoHeight < this.alturaMinima ||
        video.videoWidth < this.larguraMinima
      ) {
        this.mensagem.titulo = "Atenção";
        this.mensagem.texto =
          `A resolução deste arquivo de vídeo é baixa - ${video.videoHeight}x${video.videoWidth}! A resolução mínima é de ` +
          this.alturaMinima +
          `x` +
          this.larguraMinima +
          ` pixels.`;
        this.video = "";
        this.$emit("onMensagem", this.mensagem);
      }

      if (
        video.videoHeight > this.alturaMaxima ||
        video.videoWidth > this.larguraMaxima
      ) {
        this.mensagem.titulo = "Atenção";
        this.mensagem.texto =
          `A resolução deste arquivo de vídeo é muito alta - ${video.videoHeight}x${video.videoWidth}! A resolução máxima é de ` +
          this.alturaMaxima +
          `x` +
          this.larguraMaxima +
          ` pixels.`;
        this.video = "";
        this.$emit("onMensagem", this.mensagem);
      }
    },

    play() {
      this.$refs.video.play();
    },

    pause() {
      this.$refs.video.pause();
    },

    stop() {
      this.$refs.video.pause();
      this.$refs.video.currentTime = 0;
    },

    fullScreen() {
      this.$refs.video.webkitEnterFullscreen();
    },

    abrirDialogoExcluirVideo() {
      this.$refs.dialogoExcluirVideo.abrir();
    },

    excluirVideo() {
      this.excluindo = true;
      try {
        this.video = "";
        this.$refs.dialogoExcluirVideo.fechar();
        this.$emit("onExcluir");
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao excluir vídeo");
      } finally {
        this.excluindo = false;
      }
    },
  },

  watch: {
    value: {
      handler: function (newValue, oldValue) {
        this.video = newValue;
      },
      immediate: true,
    },
  },
};
</script>

<style>
</style>